'use client';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { routing } from '@/i18n/routing';

interface LanguageSwitcherProps {
  locale: string;
  alternates?: Record<string, string>;
}

export function LanguageSwitcher({ locale, alternates }: LanguageSwitcherProps) {
  return (
    <Select
      onValueChange={(next) => {
        window.location.assign(alternates?.[next] ?? `/${next}`);
      }}
      value={locale}
    >
      <SelectTrigger aria-label="Language" className="w-[72px] lg:w-[88px]">
        <SelectValue />
      </SelectTrigger>

      <SelectContent>
        {routing.locales.map((lang) => (
          <SelectItem key={lang} value={lang}>
            {lang.toUpperCase()}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
